import React, { useState } from "react";

import { Icon } from "@iconify/react";
import { Button, Row, Space } from "antd";
import Title from "antd/es/typography/Title";

import RentalRequestList from "js/components/Properties/PropertyDetails/PropertyDetailsSections/RentalRequestList";
import { RentalRequestProps } from "js/components/Properties/types";

import RentalApplicationModal from "js/pages/Tenants/CreateRentalApplication";

import "styles/pages/Properties/PropertyForm.scss";

const RentalRequestHistorySection: React.FC<RentalRequestProps> = ({
  propertyRentalHistoryData,
  propertyId,
  readOnly = false,
}) => {
  const [showRentalApplicationModal, setShowRentalApplicationModal] =
    useState(false);

  return (
    <>
      <Row
        justify="space-between"
        align="middle"
        style={{
          marginBottom: propertyRentalHistoryData.length !== 0 ? 10 : 0,
        }}
      >
        <Space direction="horizontal" align="center" style={{ gap: 5 }}>
          <Icon fontSize={18} icon="bx:file" />
          <Title level={5}>Historial de Solicitudes de Renta</Title>
        </Space>
        {!readOnly && propertyRentalHistoryData.length !== 0 && (
          <Button
            color={"geekblue"}
            variant={"filled"}
            onClick={() => setShowRentalApplicationModal(true)}
          >
            Crear Solicitud de Renta
          </Button>
        )}
      </Row>
      <RentalRequestList
        propertyRentalHistoryData={propertyRentalHistoryData}
        propertyId={propertyId}
        onCreateRentalRequest={() => setShowRentalApplicationModal(true)}
        readOnly={readOnly}
      />
      {!readOnly && (
        <RentalApplicationModal
          isOpen={showRentalApplicationModal}
          onOpenChange={setShowRentalApplicationModal}
          propertyId={propertyId}
        />
      )}
    </>
  );
};

export default RentalRequestHistorySection;
